module.exports = __webpack_public_path__ + "static/media/PrivacyPolicyNOD.d9c42e27.pdf";